import React from 'react'
// import PropTypes from 'prop-types'

import { 
  MainTitle, Subtitle,
  TextContent, HighlightText,
  JsonCodeStyle,
} from '../../../Shared';

import { StyledSeparated } from '../FindNearSegments/FindNearSegments.styled';

const Distance = props => {
  const responseSuccess = {
    "code": 200,
    "message": "success",
    "data": 64.10999999999997
  }

  const responseErrors = {
    "code": 401,
    "message": "Unauthorized. Token error",
    "errors": [],
    "debugError": {}
  }

  return (
    <div>
      <MainTitle>Distance</MainTitle>
      <TextContent>Get the user's travel distance</TextContent>
      <Subtitle id="request-distance">Request</Subtitle>
      <TextContent><b><i>URI: </i></b><HighlightText>/api/get-distance</HighlightText> </TextContent>
      <TextContent><b><i>Method: </i></b>@GET</TextContent>
      <TextContent><b><i>Authorization:</i></b> Bearer Token</TextContent>

      <Subtitle id="response-distance">Response</Subtitle>
      <Subtitle isSmall id="success-distance">Success</Subtitle>
      <JsonCodeStyle data={responseSuccess} />

      <Subtitle isSmall id="success-distance">Errors</Subtitle>
      <TextContent>Unauthorized</TextContent>
      <JsonCodeStyle data={responseErrors} />

      <StyledSeparated />
    </div>
  )
}

Distance.propTypes = {

}

export default Distance
